import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/** Reads broker provider metadata only — never calls a broker SDK directly (ADR-038). */
export const brokerService = {
  async listBrokers(): Promise<ApiRecord[]> {
    const response = await apiClient.get<ApiRecord[]>(endpoints.brokers.root);
    return response.data;
  },
  async getStatus(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.brokers.status);
    return response.data;
  },
  async getCapabilities(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.brokers.capabilities);
    return response.data;
  },
  async getBrokerDetail(providerId: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.brokers.detail(providerId));
    return response.data;
  },
};
